import { render, staticRenderFns } from "./WebhookLogs.vue?vue&type=template&id=f0b82460&scoped=true"
import script from "./WebhookLogs.vue?vue&type=script&lang=js"
export * from "./WebhookLogs.vue?vue&type=script&lang=js"
import style0 from "./WebhookLogs.vue?vue&type=style&index=0&id=f0b82460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b82460",
  null
  
)

export default component.exports